import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiBadge: MuiComponent<"MuiBadge"> = {
  styleOverrides: {
    badge: ({ ownerState }) => ({
      ...(ownerState.color === "success" && {
        fontSize: '11px',
        fontWeight: 700,
        backgroundColor: Colors.Green,
      }),
      ...(ownerState.color === "error" && {
        fontSize: '11px',
        fontWeight: 700,
        backgroundColor: Colors.Red,
      }),
    }),
  },
};
